import type { ReactNode } from 'react'
import { BrowserRouter } from 'react-router'

import { CallProvider } from './call/CallProvider'
import { AppRoutes } from './routes'
import { SessionProvider, useSession } from './session/SessionProvider'
import { AppUpdatePrompt } from './components/AppUpdatePrompt'
import { StreamManager } from './stream/StreamManager'
import { ThemeProvider } from './theme/ThemeProvider'

/**
 * Uygulama kokU: saglayicilar + router.
 *
 * ## `basename` Vite'in `BASE_URL`inden geliyor
 *
 * Uretimde SPA `/app/` altinda servis ediliyor; gelistirmede Vite de
 * `base: '/app/'` yapilandirmasi yuzunden ayni yolda sunuyor. Yolu elle
 * yazmak, dev ve prod'un ayrismasi icin acik davetiye olurdu.
 */
export default function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <SessionProvider>
        <ThemedApp>
          {/*
            `StreamManager` router outlet'inin USTUNDE. Boylece baska bir
            konusmaya gitmek, ayarlari acmak veya sidebar'i kapatmak bir
            uretimi YIKMIYOR - okuyucular gezinmeden bagimsiz yasiyor.
          */}
          <StreamManager>
            {/* Sesli gorusme de router'in USTUNDE: yeni sohbette ilk tur
                adresi degistirince kapanmasin (bkz. `CallProvider`). */}
            <CallProvider>
              <AppRoutes />
            </CallProvider>
            {/* Android uygulamasi: acilista ve istekle guncelleme denetimi
                (eklentisi olmayan ortamlarda hicbir sey yapmaz). */}
            <AppUpdatePrompt />
          </StreamManager>
        </ThemedApp>
      </SessionProvider>
    </BrowserRouter>
  )
}

/**
 * `ThemeProvider`, `SessionProvider`in ICINDE: sunucudaki tema tercihini
 * okuyabilmesi icin `useSession()`e ihtiyaci var. Ayri bir bilesen olmasinin
 * sebebi bu - `App` bilesenin gövdesinde hook cagirmadan `useSession()`e
 * erisemez.
 */
function ThemedApp({ children }: { children: ReactNode }) {
  const { state } = useSession()
  return <ThemeProvider serverTheme={state?.user?.theme}>{children}</ThemeProvider>
}
